// extracted by mini-css-extract-plugin
export default {"container":"SideTitle_container__90wOA","left":"SideTitle_left__Hs+FH","support":"SideTitle_support__Rj9rR","text":"SideTitle_text__qXE5g","arrowIcon":"SideTitle_arrowIcon__DAWGa"};